import { Component, Input, Output, EventEmitter } from '@angular/core';

import { User, UserList } from '@core/services/user';

import { ContactSummary } from '../../../models/contactsummary';

@Component({
  selector: 'spark-contacts-contact-list-view',
  templateUrl: './contact-list-view.component.html'
})
export class ContactListViewComponent {
  @Input()
  contacts!: ContactSummary[];

  @Input()
  users: UserList = new UserList([]);

  @Input()
  isNavigatable: boolean = false;

  @Output()
  clicked: EventEmitter<ContactSummary> = new EventEmitter<ContactSummary>();

  constructor() {}

  public onClick(contact: ContactSummary): void {
    this.clicked.emit(contact);
  }

  public findUser(portfolioId: string | null): User | undefined {
    return this.users.getByPortfolioId(portfolioId ?? '');
  }
}
